<template>
  <div>
    <div class="infotit infotitbg1">优势产品<span>ADVANTAGEOUS PRODUCTS</span></div>
    <div class="mainInfoOut">
      <span class="topleft"></span>
      <div class="mainData">
        <div>
          <span class="leftLine"></span>
        </div>
        <div class="rightView">
          <div class="boxes" :class="item.noneTab ? 'noneTab' : ''" v-for="(item, index) in infoBox" :key="index" @click="popupClick(item.tit)">{{item.tit}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      infoBox: [
        {tit: '市域社会治理现代化工程', },
        {tit: '矛盾纠纷多元化解', },
        {tit: '数字政法统一管理平台', noneTab: true },
        {tit: '智慧党建管理服务云平台', },
        {tit: '城市生命线安全建设工程', },
        {tit: '全维度企业服务平台', },
        {tit: '情指行一体化实战应用平台', noneTab: true },
        {tit: '智慧养老助残服务', },
      ]
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    popupClick(item) {
      let isJupm = true
      switch (item) {
        case '智慧养老助残服务':
          isJupm = false
          this.$emit('popupData', item)
          break;
        case '情指行一体化实战应用平台':
          isJupm = false
          break;
        case '数字政法统一管理平台':
          isJupm = false
          break;
      }
      isJupm ? this.navigator({name: 'detail', query: {title: item}}) : ''
    },
  },
  destroyed() {
  }
};
</script>

<style lang="less" scoped>

.mainInfoOut{
  width: 341px;
  min-height: 312px;
  margin: 0 auto;
  margin-top: 21px;
  position: relative;
  //background-color: #091a2e58;
  background-image: url("~@/image/popupBg.png");
  background-size: 100% 100%;
  padding-top: 32px;
  padding-left: 22px;
  padding-bottom: 22px;
  box-sizing: border-box;
  .topleft{
    position: absolute;
    width: 24px;
    height: 23px;
    left: 0;
    top: -1px;
    display: block;
    background-image: url("~@/image/paragraphBgAngle.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .mainData{
    display: grid;
    grid-template-columns: 19px 261px;
    grid-gap: 11px;
    >div{
      .leftLine{
        display: block;
        width: 1px;
        box-sizing: border-box;
        height: 95%;
        background-color: #ffffff;
        margin: 0 auto;
        margin-top: 8px;
      }
    }
    .rightView{
      .boxes{
        //margin-top: 29px;
        width: 261px;
        height: 36px;
        background-image: url("~@/image/paragraphTabBG.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        //text-indent: 5px;
        padding-left: 5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin-bottom: 36px;
        &::before{
          width: 19px;
          height: 23px;
          position: absolute;
          content: "";
          top: -23px;
          left: -30px;
          top: 8px;
          background-image: url("~@/image/localIcon.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        &:nth-last-of-type(1) {
          margin-bottom: 0;
        }
        &::after{
          width: 20px;
          height: 20px;
          position: absolute;
          content: "";
          right: -9px;
          top: 8px;
          background-image: url("~@/image/arrows.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      .noneTab{
        &::after{
          width: 20px;
          height: 20px;
          position: absolute;
          content: "";
          display: none;
          right: -9px;
          top: 8px;
          background-image: url("~@/image/arrows.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
